// Generated by Melange


function make(param) {
  return {
    byId: new Map()
  };
}

export {
  make,
}
/* No side effect */
